import React from 'react';
import uniq from 'lodash/uniq';
import isNumber from 'lodash/isNumber';
import camelCase from 'lodash/camelCase';

import {
  changeTypeDefault,
  changeTypeIncrease,
  changeTypeDecrease,
} from './scss/MarketView.module.scss';

export const formatPrice = price =>
  isNumber(price)
    ? price.toLocaleString('en', { minimumFractionDigits: 2 })
    : price;

export const filterMarketViewList = (marketViewList, category) =>
  marketViewList.filter(
    item => camelCase(item.category) === camelCase(category)
  );

export const getUniqueMarketViewCategories = marketViewList => {
  return uniq(marketViewList.map(item => item.category));
};

export const renderCellValue = (column, item) => {
  const priceValuesKeywords = ['change', 'price'];
  const cellValue = column.accessor(item);
  const displayName = camelCase(column.displayName);
  const shouldFormatCell = priceValuesKeywords.some(keyword =>
    displayName.includes(keyword)
  );

  if (!shouldFormatCell) {
    return cellValue;
  }

  const changeType = camelCase(item.changeType);
  const changeTypeClassNameMap = {
    increase: changeTypeIncrease,
    decrease: changeTypeDecrease,
  };

  const cellClassName = changeTypeClassNameMap[changeType] || changeTypeDefault;
  return <span className={cellClassName}>{cellValue}</span>;
};
